import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';

import RaisedButton from 'material-ui/RaisedButton';

import UploadDialog from './UploadDialog';

import createFetcher from 'lib/createFetcher';

const postImage = img => createFetcher('/api/patient/v2/images/', { method: 'POST', ...img }, {}, false);

export class UploadAvatarDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      scale: 1,
      avatar: null,
      image: null,
    };
  }

  componentDidMount() {
    createFetcher('/api/patient/v2/images/', {}, {}, false)
      .then(res => res.blob())
      .then(blob => {
        console.log(blob);
        if (blob.size !== 0) {
          const data = URL.createObjectURL(blob);
          this.setState({ avatar: data });
        }
      })
      .catch(console.error);
  }

  handleOpen = () => {
    this.setState({ visible: true });
  };

  handleClose = () => {
    this.setState({ visible: false, image: null });
  };

  handleSelectImage = () => {
    if (this.imageUploadRef) this.imageUploadRef.click();
  };

  handleNewImage = e => {
    this.setState({ image: e.target.files[0] });
  };

  handleScale = (_, v) => {
    const scale = parseFloat(v);
    this.setState({ scale });
  };

  handleSetEditorRef = editor => (this.editor = editor);
  handleSetImageRef = r => (this.imageUploadRef = r);

  handleSave = () => {
    let imgUri = this.editor.getImageScaledToCanvas().toDataURL('image/jpeg');
    this.setState({ avatar: imgUri });

    fetch(imgUri)
      .then(res => res.blob())
      .then(body => postImage({ body }))
      .then(() => this.handleClose())
      .catch(console.error);
  };

  render() {
    const { localeMessage, editing } = this.context;
    const { image, visible, avatar, scale } = this.state;

    return (
      <Row center="xs" start="sm">
        <UploadDialog
          visible={visible}
          image={image}
          scale={scale}
          imageUploadRef={this.imageUploadRef}
          onSaveImage={this.handleSave}
          onClose={this.handleClose}
          onSetEditorRef={this.handleSetEditorRef}
          onSetImageRef={this.handleSetImageRef}
          onUploadImage={this.handleNewImage}
          onSelectImage={this.handleSelectImage}
          onScale={this.handleScale}
          locale={localeMessage}
        />
        {avatar && [
          <Col xs={7} sm={7} md={6} lg={5} key="pic1">
            <p key="profile-picture">
              <img className="avatar" src={avatar} width="150rem" height="auto" style={{ borderRadius: '50%' }} />
            </p>
          </Col>,
          <Col xs key="pic2">
            {editing && (
              <RaisedButton
                key="change-profile-picture"
                label={localeMessage('profile.avatar.change')}
                onClick={this.handleOpen}
                secondary
              />
            )}
          </Col>,
        ]}
        {!avatar && editing && (
          <RaisedButton label={localeMessage('profile.avatar.new')} onClick={this.handleOpen} primary />
        )}
      </Row>
    );
  }
}

const mapStateToProps = state => ({
  pictureID: state.session.picture_id,
});

UploadAvatarDialog.contextTypes = {
  localeMessage: PropTypes.func,
  editing: PropTypes.bool,
};

export default connect(mapStateToProps, null)(UploadAvatarDialog);
